import { $modelSchemas } from './states';
import { fetchModelSchemas } from './effects';

// Fetch list of models and their schemas
$modelSchemas.on(fetchModelSchemas.doneData, (_, data) => data);
